import {useMutation} from "@tanstack/react-query";
import moment from "moment";
import {downloadFile} from "../../../../../util/FileDownload";
import {AxiosError} from "axios";
import {useModal} from "../../../../../hooks";
import { downloadShipmentFile } from "../../../../../api/order/OrdersApi";
import { OrdersShipmentDeliveryConfirmFileType } from "../../../../order/orders/detail/interface";

export const usePostOrderShipmentDownloadShipmentFile = () => {
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: OrdersShipmentDeliveryConfirmFileType) => downloadShipmentFile(data),
        onSuccess: (res, variables) => {
            if (res instanceof Blob) {
                const now = moment().format("YYYY_MM_DD_hh_mm")

                downloadFile(res, variables?.fileOrgname);
            }
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            handleModal({
                isOpen: true,
                contents: "엑셀파일작성처리하는 도중, 서버오류가 발생하였습니다.",
                type: "alert",
            });
        },
    });

    return {mutate};
};
